import React from "react";
const IconQuestion = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 4.55a1 1 0 0 1-1-1v-.05a1 1 0 1 1 2 0v.05a1 1 0 0 1-1 1Zm-.97-5.374c.672-.096 1.168-.248 1.488-.456.32-.208.48-.472.48-.792 0-.264-.1-.472-.3-.624-.2-.152-.488-.228-.864-.228-.664 0-1.316.212-1.956.636L7.05 6.44a4.575 4.575 0 0 1 1.32-.732 4.615 4.615 0 0 1 1.656-.288c.92 0 1.636.208 2.148.624.512.416.768.964.768 1.644 0 .84-.328 1.468-.984 1.884a4.784 4.784 0 0 1-1.068.497v1.123H9.03V9.176Z"
      fill="currentColor"
    />
  </svg>
);
export default IconQuestion;
